import { render, staticRenderFns } from "./SvgStandardOfferType.vue?vue&type=template&id=6627bb66&scoped=true"
import script from "./SvgStandardOfferType.vue?vue&type=script&lang=js"
export * from "./SvgStandardOfferType.vue?vue&type=script&lang=js"
import style0 from "./SvgStandardOfferType.vue?vue&type=style&index=0&id=6627bb66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6627bb66",
  null
  
)

export default component.exports